import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchSliders } from "../../../Redux/Slices/Slider";
import { resolveStorageUrl } from "../../../Helper/CoreHelper";
import "./HomeCarousel.css";

const hideBrokenSlide = (event) => {
  const slide = event.currentTarget.closest(".modern-carousel-slide");
  if (slide) {
    slide.style.display = "none";
  }
};

const HomeCarousel = () => {
  const dispatch = useDispatch();
  const { slidersData } = useSelector((state) => state?.Slider);

  const fetchSlidersData = useCallback(() => {
    dispatch(FetchSliders());
  }, [dispatch]);

  useEffect(() => {
    if (!slidersData || (Array.isArray(slidersData) && !slidersData.length)) {
      fetchSlidersData();
    }
  }, [fetchSlidersData, slidersData]);

  const filteredSliders = useMemo(() => {
    if (!Array.isArray(slidersData)) return [];
    return slidersData
      .filter((item) => /^https?:\/\//i.test(item?.image))
      .map((item) => ({
        ...item,
        image: resolveStorageUrl(item.image),
      }))
      .filter((item) => item.image);
  }, [slidersData]);

  return (
    <section className="modern-carousel-section">
      <div className="modern-carousel-container">
        <div className="modern-carousel-header">
          <h2 className="modern-carousel-title">
            Trusted by <span className="modern-carousel-highlight">2500+</span> Leading Companies
          </h2>
          <p className="modern-carousel-subtitle">
            Join top CA firms and businesses already using our platform
          </p>
        </div>

        <div className="modern-carousel-wrapper">
          {/* First Row - Left to Right */}
          <div className="modern-carousel-track">
            {filteredSliders.length > 0 &&
              [...filteredSliders, ...filteredSliders].map((logo, index) => (
                <div className="modern-carousel-slide" key={`row1-${index}`}>
                  <img
                    src={logo.image}
                    className="modern-carousel-img"
                    alt={logo.alt || `Company logo ${index + 1}`}
                    loading="lazy"
                    onError={hideBrokenSlide}
                  />
                </div>
              ))}
          </div>
          
          {/* Second Row - Right to Left */}
          <div className="modern-carousel-track-reverse">
            {filteredSliders.length > 0 &&
              [...filteredSliders, ...filteredSliders].map((logo, index) => (
                <div className="modern-carousel-slide" key={`row2-${index}`}>
                  <img
                    src={logo.image}
                    className="modern-carousel-img"
                    alt={logo.alt || `Company logo ${index + 1}`}
                    loading="lazy"
                    onError={hideBrokenSlide}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCarousel;
